import { parseTime } from '@/utils/util'
export const searchForm = {
}

export const articleSearchForm = {
  path: '',
  created_at_start: '',
  created_at_end: '',
}

export const form = {
  name: '', // 简称
  line_id: undefined, // 业务线id
  pinyin: '', // 全称
  category: undefined, // 地图类型
  sync_xml_loc: '', // XML同步地址
  typeids: [], // 类别
  loc_rule: '', // 链接地址
  priority: '', // 权重值
  change_freq: undefined, // 更新频率
}

export const formArticle = {
  path: "", // 网站地图id
}

export const rulesArticle = {
  path: [{ required: true, message: '请输入链接', trigger: 'change' }],
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '品牌',
    dataIndex: 'brand.name',
    width: 200,
    align: 'left',
    // scopedSlots: { customRender: 'org' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 200,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 180,
    align: 'left',
    customRender(text) {
      text === 0 ? text = '--' : text = parseTime(text)
      return text
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'operator' }
  }
]

export const columnsArticle = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  // {
  //   title: '属性',
  //   dataIndex: 'category',
  //   width: 100,
  //   align: 'center',
  //   scopedSlots: { customRender: 'category' }
  // },
  {
    title: '链接地址',
    dataIndex: 'path',
    width: 200,
    align: 'left'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 120,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'operator' }
  }
]
